import { ReactNode } from 'react';
import { Separator } from 'src/shared/components/ui/separator';
import Feedback from 'src/features/plugins/outlook/components/Feedback';

interface GeneralFeedbackProps {
  title?: string;
  description?: string;
  action?: { title: string; action: () => void };
  CardContent?: ReactNode;
  Footer?: ReactNode;
  testId?: string;
}

export default function GeneralFeedback({
  title,
  description,
  action,
  CardContent,
  Footer,
  testId,
}: GeneralFeedbackProps) {
  return (
    <Feedback testId={testId} Footer={Footer}>
      <div className="flex flex-col justify-center w-full gap-2">
        {CardContent ? (
          CardContent
        ) : (
          <>
            <Feedback.Title text={title ?? 'Something went wrong'} />
            <Separator className="mb-1" />
            <Feedback.Description text={description ?? 'Please try again.'} />
            {action && <Feedback.Action text={action.title} onClick={action.action} />}
          </>
        )}
      </div>
    </Feedback>
  );
}
